webpackJsonp([35783957827783],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactHelmet = __webpack_require__(72);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _gatsbyLink = __webpack_require__(133);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var IndexWrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "e1ckx0rd0"
	})("max-width:600px;margin:0 auto;");
	
	exports.default = function () {
	  return React.createElement(
	    IndexWrapper,
	    null,
	    React.createElement(
	      _reactHelmet2.default,
	      null,
	      React.createElement(
	        "title",
	        null,
	        "Christian Gaetano \u2014 Software Engineer and Seattle Dog Dad"
	      ),
	      React.createElement("link", { rel: "canonical", href: "https://christiangaetano.com" }),
	      React.createElement("meta", {
	        name: "description",
	        content: "Biochemist turned software developer who's downright crazy about building for the web. Right now, I work with full stack JavaScript at GrapeCity, but I also spend lots of time working on open source projects, pretending to be a designer, and writing about life. Climb aboard to see what I'm up to and get in touch!"
	      })
	    ),
	    React.createElement(
	      "h1",
	      { style: { fontFamily: ["Lora", "serif"].join(", ") } },
	      React.createElement(
	        "i",
	        null,
	        "Hello,"
	      )
	    ),
	    React.createElement(
	      "p",
	      null,
	      "My name's Christian Gaetano. I'm a software engineer with a passion for building delightful & meaningful experiences on the web. And even though it's not my day job, I love helping to visually design those experiences when I can."
	    ),
	    React.createElement(
	      "p",
	      null,
	      "Since you've managed to find my personal website, I'm willing to bet you're on a mission to uncover all of my deepest, darkest secrets. Really though, you're probably looking for something specific. If that's the case, feel free to head straight to my",
	      " ",
	      React.createElement(
	        _gatsbyLink2.default,
	        { to: "/resume/" },
	        "resume"
	      ),
	      " or peruse my",
	      " ",
	      React.createElement(
	        _gatsbyLink2.default,
	        { to: "/work/" },
	        "portfolio"
	      ),
	      "."
	    ),
	    React.createElement(
	      "p",
	      null,
	      "Of course \u2014 if you're just here for a good time* \u2014",
	      " ",
	      React.createElement(
	        "i",
	        null,
	        "please"
	      ),
	      ", read on! You can check out a list of my latest writings below. If you're feeling really adventurous, you can read more about my ever changing story."
	    ),
	    React.createElement(
	      "p",
	      null,
	      React.createElement(
	        "small",
	        null,
	        "* ",
	        React.createElement(
	          "i",
	          null,
	          "You've come to the right place"
	        ),
	        "."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4e8df86ddc8811e36ab3.js